import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import { Button, Menu, MenuItem, Stack } from "@mui/material";
import { Radius } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type React from "react";
import { useState } from "react";

const ATLANTIK_URL = "https://app.atlantik.cz/";

export const GoalsFulfillmentContractingPartners = () => {
  const { t } = useResource();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAtlantikClick = () => {
    window.open(ATLANTIK_URL, "_blank", "noopener,noreferrer");
    handleClose();
  };

  return (
    <div>
      <Button
        variant="text"
        color="primary"
        onClick={handleClick}
        aria-controls={open ? "contracting-partners-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<HandshakeOutlinedIcon />}
        sx={{ textTransform: "none" }}
      >
        {t(Resources.AnalysisDetail.GoalsFulfillment.ContractingPartnersMenu.Title)}
      </Button>

      <Menu
        id="contracting-partners-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 3,
            sx: {
              mt: 1,
              minWidth: 240,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: Radius.M,
            },
          },
        }}
      >
        <Stack>
          <MenuItem onClick={handleAtlantikClick} sx={{ fontSize: 14 }}>
            {t(Resources.AnalysisDetail.GoalsFulfillment.ContractingPartnersMenu.Atlantik)}
          </MenuItem>
        </Stack>
      </Menu>
    </div>
  );
};
